import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './Button.module.less';

const Button = React.memo(
  React.forwardRef(function Button(props, ref) {
    const {
      children,
      className = '',
      size = 'normal',
      display = 'inline-block',
      color = 'primary',
      shadowless = false,
      disabled = false,
      href,
      onClick,
      ...otherProps
    } = props;

    const classes = clsx(
      // For code that needs to override styles (mostly legacy stuff)
      'btn',
      `btn-${color}`,
      `btn-${size}`,
      // Otherwise, use css module class names for actual styling
      styles.btn,
      styles[color],
      styles[size],
      {
        [styles.shadowless]: shadowless,
        [styles.block]: display === 'block',
        [styles.disabled]: disabled,
      },
      className
    );

    if (href) {
      return (
        <a
          className={classes}
          href={href}
          onClick={
            disabled
              ? e => {
                  e.preventDefault();
                }
              : onClick
          }
          ref={ref}
          {...otherProps}
        >
          {children}
        </a>
      );
    }
    return (
      <button
        className={classes}
        disabled={disabled}
        onClick={onClick}
        ref={ref}
        {...otherProps}
      >
        {children}
      </button>
    );
  })
);

Button.displayName = 'Button';
Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'normal', 'large']),
  display: PropTypes.oneOf(['inline-block', 'block']),
  color: PropTypes.oneOf([
    'none',
    'primary',
    'secondary',
    'tertiary',
    'premium',
    'teal',
    'destructive',
  ]),
  shadowless: PropTypes.bool,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  onClick: PropTypes.func,
};

export default Button;
